var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 11.732C16.9169 12.2658 15.7751 12.5684 14.5626 12.5684C10.6242 12.5684 7.43158 9.37573 7.43158 5.43737C7.43158 4.22488 7.73419 3.08306 8.26801 2.08333C4.72302 2.91415 2.08331 6.09594 2.08331 9.89426C2.08331 14.3249 5.67506 17.9167 10.1057 17.9167C13.904 17.9167 17.0858 15.277 17.9166 11.732Z",
    stroke: "#495055",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon01);
export default __webpack_public_path__ + "static/media/moon-01.43d3336a072cb002e33a87488f01da92.svg";
export { ForwardRef as ReactComponent };